import { useEffect, useState } from 'react';

type Params = {
  token: string;
  username: string;
};

export function useQueryParams() {
  const [params, setParams] = useState<Params | null | undefined>(undefined);

  useEffect(() => {
    const rawParams = new URLSearchParams(window.location.search);
    const parsedParams = Object.fromEntries(rawParams.entries()) as Params;

    if (!parsedParams.token) {
      setParams(null);
    } else {
      setParams(parsedParams);
    }
  }, []);

  return params;
}
